var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 7C9.39543 7 8.5 7.89543 8.5 9C8.5 10.1046 9.39543 11 10.5 11C11.6046 11 12.5 10.1046 12.5 9C12.5 7.89543 11.6046 7 10.5 7ZM6.5 9C6.5 6.79086 8.29086 5 10.5 5C12.7091 5 14.5 6.79086 14.5 9C14.5 11.2091 12.7091 13 10.5 13C8.29086 13 6.5 11.2091 6.5 9Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71913 0.375305C7.9089 0.13809 8.19622 0 8.5 0H12.5C12.7962 0 13.0771 0.131271 13.2671 0.358445L15.0582 2.5H18.5C19.6046 2.5 20.5 3.39543 20.5 4.5V15C20.5 16.1046 19.6046 17 18.5 17H2.5C1.39543 17 0.5 16.1046 0.5 15V4.5C0.5 3.39543 1.39543 2.5 2.5 2.5H6.01937L7.71913 0.375305ZM8.98063 2L7.28087 4.12469C7.0911 4.36191 6.80378 4.5 6.5 4.5H2.5V15H18.5V4.5H14.5909C14.2948 4.5 14.0138 4.36873 13.8238 4.14155L12.0327 2H8.98063Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIcon);
export default __webpack_public_path__ + "static/media/CameraIcon.4d8d721e598fa38d41bc0b1bdf5ee18b.svg";
export { ForwardRef as ReactComponent };